import { render, staticRenderFns } from "./cmsFooter.vue?vue&type=template&id=66efd4a2"
import script from "./cmsFooter.vue?vue&type=script&lang=js"
export * from "./cmsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports